import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { format, addMonths } from 'date-fns';

import Field from './Field';
import Calendar from './Calendar';
import DropDownView from './views/DropDownView';
import FieldDatePickerView from './views/FieldDatePickerView';
import { SNOW_SEARCH_FIELD_FOCUSED, SNOW_SEARCH_DATE_SELECTED } from './events';
import { parseDate, dateFnsLocale, createDateList, formatDateWithDayOfWeek } from '../utils/dateHelper';
import { IRoom, ILabel, ISnowSearchPlacement } from './types';
import t from './locales';

const CalendarsView = styled.div`
  display: flex;
`;

interface IProps {
  placement: ISnowSearchPlacement;
  isDropDownShown: boolean;
  selectedDateList: Date[];
  setDateList: Function;
  numOfCalendar: number;
  rooms: IRoom[]; // 日付選択後に部屋を自動セットするかどうかの判定に使用
}

const FieldDatePicker: React.FC<IProps> = (props) => {
  const { placement, selectedDateList, setDateList, numOfCalendar, isDropDownShown, rooms } = props;
  const [currentMonth, setCurrentMonth] = useState<Date>(new Date());

  function handleClick(event: React.MouseEvent) {
    const detail = { focusedField: 'date', placement };
    const clickEvent = new CustomEvent(SNOW_SEARCH_FIELD_FOCUSED, { detail });
    document.dispatchEvent(clickEvent);
  }

  function handleDateClick(event: React.MouseEvent): void {
    const selected: Date = parseDate(event.currentTarget.getAttribute('data-date'));
    if (selectedDateList.length !== 1) {
      setDateList([selected]);
    } else {
      setDateList(createDateList(selectedDateList[0], selected));
      const detail = { isRoomsEmpty: rooms.length === 0, placement };
      document.dispatchEvent(new CustomEvent(SNOW_SEARCH_DATE_SELECTED, { detail }));
    }
  }

  function handlePrevMonthClick(): void {
    setCurrentMonth(addMonths(currentMonth, -1));
  }

  function handleNextMonthClick(): void {
    setCurrentMonth(addMonths(currentMonth, 1));
  }

  function renderCalendars() {
    const calendars = [];
    for (let i = 0; i < numOfCalendar; i += 1) {
      const prevFunc = i === 0 ? handlePrevMonthClick : null;
      const nextFunc = i === numOfCalendar - 1 ? handleNextMonthClick : null;
      calendars.push(
        <Calendar
          key={`calendar-${i}`}
          selectedDateList={selectedDateList}
          handleDateClick={handleDateClick}
          handlePrevMonthClick={prevFunc}
          handleNextMonthClick={nextFunc}
          currentMonth={addMonths(currentMonth, i)} />)
    }
    return calendars;
  }

  const fieldLabel = (type: 'start'|'end'): ILabel => {
    let label = { main: '', sub: '' };
    const _formatDate = (date: Date) => {
      const formatted = formatDateWithDayOfWeek(date);
      const [main, sub] = formatted.split(' (');
      return { main, sub: sub.replace(')', '') };
    }
    if (type === 'start' && selectedDateList.length > 0) {
      label = _formatDate(selectedDateList[0]);
    }
    if (type === 'end' && selectedDateList.length > 1) {
      label = _formatDate(selectedDateList[selectedDateList.length - 1]);
    }
    return label;
  }

  return (
    <FieldDatePickerView>
      <Field
        icon="calendar_in"
        readOnly
        placeholder={t.checkIn()}
        label={fieldLabel('start')} 
        handleClick={handleClick} />
      <Field
        icon="calendar_out"
        readOnly
        placeholder={t.checkOut()}
        label={fieldLabel('end')}
        handleClick={handleClick} />
      {isDropDownShown &&
        <DropDownView align={selectedDateList.length === 1 ? 'right' : null}>
          <CalendarsView>
            {renderCalendars()}
          </CalendarsView>
        </DropDownView>}
    </FieldDatePickerView>
  );  
};

export default FieldDatePicker
